import { Directive, ElementRef, OnDestroy, OnInit, inject, input, output } from "@angular/core";
import { KeyboardService } from "common/keyboard.service";
import { fromEvent, Subscription } from "rxjs";
import { debounceTime, distinctUntilChanged, filter } from "rxjs/operators";

const DELAY = 150;

@Directive({ selector: "[stagesDebouncedChange]" })
export class DebouncedChangeDirective implements OnInit, OnDestroy {
	private elementRef = inject(ElementRef);
	private keyboardService = inject(KeyboardService);

	readonly debouncedEvent = input("keyup"); //TODO: Can we remove this input parameter and always set the debaouncedEvent to "input" as needed by global search

	readonly changed = output<string>({ alias: "stagesDebouncedChange" });

	private inputHandler!: Subscription;

	ngOnInit(): void {
		this.inputHandler = fromEvent(this.elementRef.nativeElement, this.debouncedEvent())
			.pipe(
				debounceTime(DELAY),
				filter((ev) => !this.keyboardService.isNavigationKey(ev as KeyboardEvent)),
				distinctUntilChanged(),
			)
			.subscribe(() => this.fireChanged());
	}

	ngOnDestroy(): void {
		this.inputHandler.unsubscribe();
	}

	private fireChanged(): void {
		this.changed.emit(this.elementRef.nativeElement.value);
	}
}
